import {observer} from 'mobx-react';
import {useCallback} from 'react';
import {Container, Grid, Input, Message} from 'semantic-ui-react';
import {Field, Checkbox} from 'apstra-ui-common';

import {useRackEditorStore} from '../hooks/useRackEditorStore';
import {descriptionLength, DESIGN} from '../const';
import './Summary.less';

const Summary = () => {
  const {name, description, design, setProperty, hasMlagLeafPairs, canBecomeRailCollapsed,
    supportsRails, isNew, hasRails} = useSummary();

  return (
    <Grid.Row className='re-summary'>
      <Grid.Column width={10}>
        <h4>{'Summary'}</h4>
        <Field required label='Name'>
          <Input
            fluid value={name}
            error={!name}
            minLength={1}
            maxLength={17}
            onChange={(event, {value}) => setProperty('name', value)}
          />
        </Field>
        <Field label='Description' description={`Max ${descriptionLength} characters`}>
          <Input fluid value={description} onChange={(event, {value}) => setProperty('description', value)}>
            <input maxLength={descriptionLength} />
          </Input>
        </Field>
      </Grid.Column>
      <Grid.Column width={6}>
        <h4>{'Fabric Connectivity Design'}</h4>
        <Checkbox
          radio
          name='design'
          label='L3 Clos'
          checked={design === DESIGN.L3CLOS}
          onClick={() => setProperty('design', DESIGN.L3CLOS)}
          disabled={!isNew}
        />
        <Container>
          {'Applicable when designing rack types used in 3-stage and 5-stage fabric template'}
        </Container>

        <Checkbox
          radio
          name='design'
          label='L3 Collapsed'
          checked={design === DESIGN.L3COLLAPSED}
          onClick={() => setProperty('design', DESIGN.L3COLLAPSED)}
          disabled={hasMlagLeafPairs || !isNew || hasRails}
        />
        <Container>
          {'Applicable when designing rack types used in a collapsed template (spineless)'}
        </Container>

        {supportsRails &&
          <>
            <Checkbox
              radio
              name='design'
              label='Rail Collapsed'
              checked={design === DESIGN.RAILCOLLAPSED}
              onClick={() => setProperty('design', DESIGN.RAILCOLLAPSED)}
              disabled={hasMlagLeafPairs || !canBecomeRailCollapsed || !isNew}
            />
            <Container className='last'>
              {'Applicable when designing rack types for an AI fabric'}
            </Container>
          </>
        }

        {hasMlagLeafPairs &&
          <Message warning content='MLAG leaf pairs are not allowed in L3/Rail Collapsed design' />
        }
      </Grid.Column>
    </Grid.Row>
  );
};

const useSummary = () => {
  const {rackStore} = useRackEditorStore();
  const {name, description, design, mlagLeafPairsCount, canBecomeRailCollapsed, supportsRails, isNew,
    hasRails} = rackStore;

  const setProperty = useCallback(
    (property, value) => rackStore.setProperty(property, value),
    [rackStore]
  );

  return {
    name: name || '',
    description: description || '',
    design: design,
    hasMlagLeafPairs: mlagLeafPairsCount > 0,
    setProperty,
    canBecomeRailCollapsed,
    supportsRails,
    isNew,
    hasRails
  };
};

export default observer(Summary);
